import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { AccountSelectionService } from "@front/m19-services";
import { TranslocoDirective } from "@jsverse/transloco";
import { ActivateAdsAutomationCtaComponent } from "@m19-board/shared/activate-ads-automation-cta/activate-ads-automation-cta.component";
import { OverlayLayoutComponent } from "@m19-board/overlay/overlay-layout/overlay-layout.component";
import { OverlayRule } from "@m19-board/overlay/overlay-service/overlay-rules";

@Component({
  selector: "app-bidder-off-overlay",
  imports: [TranslocoDirective, OverlayLayoutComponent, ActivateAdsAutomationCtaComponent],
  template: `
    <app-overlay-layout
      *transloco="let t"
      variant="promo"
      [title]="t('overlays.bidder_off_title')"
      [subtitle]="t('overlays.bidder_off_subtitle')"
    >
      <p overlayBody>{{ t("overlays.bidder_off_reason") }}</p>
      <app-activate-ads-automation-cta overlayCta [accountMarketplace]="accountMarketplace()" />
    </app-overlay-layout>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BidderOffOverlayComponent {
  private readonly accountSelectionService = inject(AccountSelectionService);

  static readonly rule = OverlayRule.BIDDER_OFF;

  protected readonly accountMarketplace = toSignal(this.accountSelectionService.singleAccountMarketplaceSelection$, {
    requireSync: true,
  });
}
